import React, { useState } from "react";
import Chart from "./Charts";
import MyNft from "../component/NftJourney/MyNft";
function NftJourney() {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [toggle, setToggle] = useState(false);

  const toggleComp = {
    toggleTrue: () => {
      setToggle(true);
    },
    toggleFalse: () => {
      setToggle(false);
    },
  };

  return (
    <>
      {toggle ? (
        <>
          <MyNft
            title={"Home"}
            MyNft={"My NFTs"}
            heading="Home"
            subheading={"GamingGgGGGgGgGgGgGg Arcade"}
            pass={"ALPHA PASS# 981"}
            descHeading="Discription"
            list={
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. "
            }
            price="2.55"
            buyNow="Buy Now"
            toggleTrue={toggleComp.toggleTrue}
            toggleFalse={toggleComp.toggleFalse}
            Chart={Chart}
            setIsOpen={setIsOpen}
            modalIsOpen={modalIsOpen}
          />
        </>
      ) : (
        <>
          <MyNft
            title={"Home"}
            MyNft={"My NFTs"}
            heading="My NFTs"
            subheading={"Gaming Arcade"}
            pass={"ALPHA PASS# 981"}
            descHeading="Discription"
            list={
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. "
            }
            price="2.55"
            buyNow="Buy Now"
            toggleTrue={toggleComp.toggleTrue}
            toggleFalse={toggleComp.toggleFalse}
            Chart={Chart}
            setIsOpen={setIsOpen}
            modalIsOpen={modalIsOpen}
          />
        </>
      )}

      {/* SECOND MODAL */}
    </>
  );
}
export default NftJourney;
